import {Component, OnInit} from '@angular/core';
import {UserCoffeeService} from '../../../services/user/user-coffee.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-coffee-make',
  styleUrls: ['./coffee-make.component.scss'],
  templateUrl: './coffee-make.component.html',
})
export class CoffeeMakeComponent implements OnInit {

  public isSuccess = false;
  public errorMessage: string;
  public makeCoffeeForm: FormGroup;

  constructor(private userCoffeeService: UserCoffeeService,
              private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.makeCoffeeForm = this.formBuilder.group({
      coffeeCode: ['', Validators.required]
    });
  }

  makeCoffeeFormSubmit(): void {
    const coffeeCode = this.makeCoffeeForm.controls.coffeeCode.value;
    this.userCoffeeService.makeCoffee(coffeeCode).subscribe({
      next: value => {
        this.isSuccess = true;
        this.errorMessage = '';
      },
      error: e => {
        this.isSuccess = false;
        this.errorMessage = e.error.message;
      }
    });
  }
}
